import {css} from 'lit';
export const styles = css`:host {
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  background-color: var(--gray-new-000);
  border-radius: 10px;
  cursor: pointer;
}

.tags {
  position: absolute;
  display: flex;
  justify-content: center;
  z-index: 1;
}

.tag {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-left: 1px;
  margin-right: 1px;
  border: 2px solid var(--contrast-light);
  border-radius: 50%;
}

.tag.color-10 {
    background-color: var(--tag-color-10);
  }

.tag.color-20 {
    background-color: var(--tag-color-20);
  }

.tag.color-30 {
    background-color: var(--tag-color-30);
  }

.tag.color-40 {
    background-color: var(--tag-color-40);
  }

.tag.color-50 {
    background-color: var(--tag-color-50);
  }

.tag.color-60 {
    background-color: var(--tag-color-60);
  }

.tag.color-70 {
    background-color: var(--tag-color-70);
  }

.tag.color-80 {
    background-color: var(--tag-color-80);
  }

.tag.color-90 {
    background-color: var(--tag-color-90);
  }

.tag.color-100 {
    background-color: var(--tag-color-100);
  }

.tag.color-110 {
    background-color: var(--tag-color-110);
  }

.tag.color-120 {
    background-color: var(--tag-color-120);
  }

.tag.color-130 {
    background-color: var(--tag-color-130);
  }

.tag.color-140 {
    background-color: var(--tag-color-140);
  }

.tag.color-150 {
    background-color: var(--tag-color-150);
  }

.tag.color-160 {
    background-color: var(--tag-color-160);
  }

.tag.color-170 {
    background-color: var(--tag-color-170);
  }

.tag.color-180 {
    background-color: var(--tag-color-180);
  }

.tag.color-190 {
    background-color: var(--tag-color-190);
  }

.tag.color-200 {
    background-color: var(--tag-color-200);
  }

.tag.color-210 {
    background-color: var(--tag-color-210);
  }

.tag.color-220 {
    background-color: var(--tag-color-220);
  }

.tag.color-230 {
    background-color: var(--tag-color-230);
  }

.tag.color-240 {
    background-color: var(--tag-color-240);
  }

.tag.color-250 {
    background-color: var(--tag-color-250);
  }

.info {
  color: var(--dark-text);
}

bu-file-icon {
  --file-icon-width: 24px;
  --file-icon-font-size: 10px;
  --file-icon-parent-background: var(--gray-new-000);

  margin-right: 16px;
}

::slotted(*) {
  margin: 0;
  font-weight: 400;
  font-size: var(--font-size-base);
  word-break: break-all;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

:host(:active) {
  background-color: var(--gray-new-200);
}

:host(:active) bu-file-icon {
    --file-icon-parent-background: var(--gray-new-200);
  }

:host([layout='thumb']) {
  position: relative;
  padding-top: 100%;
}

:host([layout='thumb']) .thumb-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 8px;
    min-height: 1px;
    min-width: 1px;
  }

:host([layout='thumb']) .figure {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    min-height: 1px;
  }

:host([layout='thumb']) .figure bu-file-icon {
      --file-icon-width: 52px;
      --file-icon-font-size: 18px;

      margin-right: unset;
    }

:host([layout='thumb']) .figure img {
      width: 100%;
      height: 100%;
      -o-object-fit: cover;
         object-fit: cover;
      border-radius: 8px;
    }

:host([layout='thumb']) .tags {
    position: absolute;
    top: -6px;
    left: 50%;
    display: flex;
    width: 70%;
    transform: translateX(-50%);
  }

:host([layout='thumb']) .info {
    display: flex;
    flex: 0;
    align-items: center;
    margin-top: 8px;
    padding-left: 8px;
    padding-right: 8px;
  }

:host([layout='thumb']) ::slotted(*) {
    -webkit-line-clamp: 2;
  }

:host([layout='list']) {
  height: 52px;
}

:host([layout='list']) .info {
    flex: 1;
    display: flex;
    align-items: center;
  }

:host([layout='list']) .info ::slotted(*) {
      flex: 1;
      -webkit-line-clamp: 1;
    }

:host([layout='list']) .info span {
      font-size: var(--font-size-sm);
      color: var(--dark-text-secondary);
    }

:host([layout='list']) .tags {
    top: 50%;
    left: -0;
    flex-direction: column;
    transform: translate(-50%, -50%);
  }

@media (max-width: 767px) {
    :host([layout='list']) .info {
      flex-wrap: wrap;
    }

      :host([layout='list']) .info ::slotted(*) {
        flex-basis: 100%;
      }
        :host([layout='list']) .info span.owner {
          display: none;
        }

        :host([layout='list']) .info span.size:not(:empty)::before {
          content: '•';
          margin-left: 4px;
          margin-right: 4px;
        }
  }

@media (min-width: 768px) {

:host([layout='list']) {
    height: 68px;
    border-radius: 0;
    background-color: var(--contrast-light)
}

    :host([layout='list']) bu-file-icon {
      --file-icon-parent-background: var(--contrast-light);
    }

    :host([layout='list']) .tags {
      transform: translate(-10%, -50%);
    }

    :host([layout='list']) .info > span {
      margin-left: 16px;
      flex-basis: 100px;
    }

      :host([layout='list']) .info > span:empty::before {
        content: '—';
      }

      :host([layout='list']) .info > span.created-at > span {
        display: none;
      }

      :host([layout='list']) .info > span.owner {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }

      :host([layout='list']) .info > span.size {
        flex-basis: 50px;
      }
  }

@media (min-width: 768px) {

:host([layout='list']:active) {
    background-color: var(--gray-new-000)
}

    :host([layout='list']:active) bu-file-icon {
      --file-icon-parent-background: var(--gray-new-000);
    }
  }
`;
export default styles;
